import { SplashLoader } from '@mi-front/ui';
import { useGrowthbookUserInit } from '../hooks/useGrowthbookUserInit';
import { useBugsnagIdentify } from './bugsnag/useBugsnagIdentify';
import { PostHogTracking } from './posthog/PostHogTracking';

export function IntegrationsTracking({ children }: { children: React.ReactNode }) {
  useBugsnagIdentify();

  if (!useGrowthbookUserInit()) {
    return <SplashLoader />;
  }

  return (
    <>
      <PostHogTracking />
      {children}
    </>
  );
}
